import React from "react";

interface IGeneralVisitTile{
  counterValue: number;
  consultationTitle: string;
  isUnlimited:boolean;
}

const GeneralVisitTile = ({ counterValue, consultationTitle, isUnlimited }: IGeneralVisitTile) => {
  return (
    <div className="bg-white p-3 rounded-lg flex justify-between items-center text-sm font-semibold">
      <div className="flex gap-2 items-center">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-violet-3">
          <div className="font-bold text-base">{counterValue}</div>
        </div>
        <div>{consultationTitle}</div>
      </div>
      {isUnlimited && <div className="text-violet-1">Unlimited</div>}
    </div>
  );
};

export default GeneralVisitTile;
